<div class="paginator-counter">
	<span class="text">{{ 'PAGINATOR_COUNTER.DISPLAYED' | translate }}</span>
	<span class="number">{{ lockInfiniteScroll ? 0 : currentPage * pageSize }} </span>
	<span class="text">-</span>
	<span class="number">{{ totalItems <= (currentPage + 1) * pageSize ? totalItems : (currentPage + 1) * pageSize }} </span>
	<span class="text">{{ 'PAGINATOR_COUNTER.OF' | translate }}</span>
	<span class="number"> {{ totalItems >= 0 ? totalItems : 0 }}</span>
	<span class="text">{{ 'PAGINATOR_COUNTER.ELEMENTS' | translate }}</span>
</div>
